import * as React from 'react';

import { Text } from '@components/common';
import { AvatarFromId } from '@components/common/Avatar';
import { useUser } from '@hooks/useUser';

interface Props {
  message?: string;
}

export const UserMessage: React.FC<Props> = ({ message }) => {
  const { id, first_name } = useUser();

  if (!message) {
    return null;
  }

  return (
    <div className='py-4'>
      <div className='flex items-center space-x-2'>
        <AvatarFromId userId={id} />
        <Text bold h='400'>
          {first_name || 'You'}
        </Text>
      </div>
      <Text h='400' className='mt-2'>
        {message}
      </Text>
    </div>
  );
};
